export const TypeNotification = {
  one: 'type-one',
  two: 'type-two',
  three: 'type-three',
};
